// ============================================================================
// GST SERVICE
// ============================================================================
// Backend wraps responses in ApiResponse<T>.

import { get } from '../client/axiosClient';
import { gstEndpoints } from '../endpoints/gst.endpoints';
import type { GstModuleInfo } from '../types/gst.types';

class GstService {
  /**
   * Reports how the GST module is wired for the calling tenant.
   *
   * Throws on 404, which is what the backend returns when the module is not
   * enabled for this tenant. Callers should treat that as "not installed"
   * rather than as an error worth alarming the user about — see
   * GstModuleInfoScreen.
   */
  async getModuleInfo(): Promise<GstModuleInfo> {
    const response = await get<any>(gstEndpoints.moduleInfo());
    return response.data?.data as GstModuleInfo;
  }
}

export const gstService = new GstService();
export default gstService;
